export default __webpack_public_path__ + "static/media/chest.aaff0cc9.png";